// Components
import { Icon } from 'components/icon'
import { CurrentAccount } from './components'
import { SpookySwapLink } from './components/swap/SpookySwapLink'
import { Select } from './components/chainSelect'
import React, { useState } from "react";
// Constants
import { NAVIGATION_LINKS, supportedChains } from './navbar.constants'
// Contexts
import { useWalletContext } from 'providers/WalletProvider'
import { useSpendableTokenContext } from 'providers/SpendableTokenProvider'

// Styles
import {
  Attention,
  ChangeNetworkButton,
  ConnectButton,
  LeftSide,
  Logo,
  LogoContainer,
  LogoText,
  NavbarContainer,
  NavbarLink,
  NavbarLinks,
  NavbarLinkText,
  RightSide,
  StyledNavbar,
  WarningIcon,
  WarningText,
} from './navbar.styles'

export const Navbar = (): React.ReactElement => {
  const state = useWalletContext()

  const {
    chainId,
    isUserConnected,
    isChainConnected,
    isChainAccepted,
    currentAccount,
    targetNetwork,
    swapToTarget,
    connect,
  } = state

    const { balanceUSDC, isLoadingUSDC, sufix, isLoadingWpoktEth, balanceWpoktEth } = useSpendableTokenContext()

    const chains: string[] = supportedChains;
    const [firstSelect, setFirstSelect] = useState(chains[0]);

  return (
    <StyledNavbar>
      <NavbarContainer>
        <LeftSide>
          <LogoContainer to={'/'}>
            <Logo title='SafePOKT' src={'/logo.png'} />
            <LogoText>SafePOKT</LogoText>
          </LogoContainer>
          <NavbarLinks>
            {NAVIGATION_LINKS.map(({ name, url, icon }) => (
              <NavbarLink to={url} key={url}>
                <Icon icon={icon} />
                <NavbarLinkText>{name}</NavbarLinkText>
              </NavbarLink>
            ))}
          </NavbarLinks>
        </LeftSide>

        <RightSide>
          {isUserConnected && currentAccount ? (
            (isChainConnected || isChainAccepted) ? (
              <>
              <Select options={chains} value={firstSelect} dropUp={false} onChange={v => setFirstSelect(v)} small={false} enabled={isUserConnected} />
                {!isLoadingUSDC && balanceUSDC === 0 && chainId !== '0x1' && <SpookySwapLink chain={"normal"} />}
                {!isLoadingWpoktEth && balanceWpoktEth === 0 && chainId === '0x1' && <SpookySwapLink chain={"ethereum"} />}
                { (chainId !== '0x1') 
                     ? ( <CurrentAccount account={currentAccount} chain={"normal"} balance={balanceUSDC} currency={sufix} isLoading={isLoadingUSDC} /> )
                     : (<CurrentAccount account={currentAccount} chain={"ethereum"} balance={balanceWpoktEth} currency={"WPOKT"} isLoading={isLoadingWpoktEth} /> )
                }
                
              </>
            ) : (
              <>
                <Attention>
                  <WarningIcon icon='error' />
                  <WarningText>Wrong Network</WarningText>
                </Attention>
                <ChangeNetworkButton onClick={() => {swapToTarget(false)}}>
                  Change to {targetNetwork?.chainParams.chainName}
                </ChangeNetworkButton>
              </>
            )
          ) : (
            <ConnectButton
              // disabled={isMetamaskLoading || !hasMetamask}
              onClick={() => connect && connect()}
            >
              Connect
            </ConnectButton>
          )}
          {/* <Settings /> */}
        </RightSide>
      </NavbarContainer>
    </StyledNavbar>
  )
}
